/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content1/view.blocks to change it.
import Comms from './Comms/index'
import Content from './Content/index'
import Letter from './Letter/index'
import OldLetter from './OldLetter/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Content1({
  children,
  viewPath = "/DesignSystem/TasksViewForm/Content"
  
}) {
  return (<React.Fragment
>
<Content
  viewPath={`${viewPath}/Content`}
/>
<Letter
  viewPath={`${viewPath}/Letter`}
/>
<OldLetter
  viewPath={`${viewPath}/OldLetter`}
/>
<Comms
  viewPath={`${viewPath}/Comms`}
/>
{children}
</React.Fragment>)
}